import * as React from 'react';
import * as styles from './buttonLabelWrapper.css';

export interface IButtonLabelWrapperProps {
  Icon: typeof React.PureComponent;
  label: string;
}

export class ButtonLabelWrapper extends React.PureComponent<IButtonLabelWrapperProps, {}> {
  public render() {
    const { Icon, label } = this.props;

    return (
      <span className={styles.label_wrapper}>
        <Icon /> {label}
      </span>
    );
  }
}
